import { createContext as P, useContext as x, useState as G, useMemo as R, useReducer as ge, useRef as W, useEffect as Se, useCallback as C } from "react";
import { jsx as v, jsxs as ye } from "react/jsx-runtime";
import { QueryClient as we, QueryClientProvider as ve, useQueryClient as Z, useQuery as xe, useInfiniteQuery as Re } from "@tanstack/react-query";
import { useRequester as Pe } from "@made-people/react-use-requester";
import { useInjectStructuredDataProducts as Ce } from "@made-people/grease-structured-data";
const b = P(
  void 0
), z = P(void 0);
function be() {
  const e = x(z);
  if (e === void 0)
    throw new Error(
      "useFacetSorting must be used within a SearchResultProvider"
    );
  return e;
}
const B = P([]), Ee = () => {
  const e = x(B);
  if (e === void 0)
    throw new Error("useExcludedFacets must be used within a SearchProvider");
  return e;
}, J = (e) => new we({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1e3,
      // 5 minutes
      gcTime: e,
      retry: 2,
      retryDelay: (t) => Math.min(1e3 * 2 ** t, 3e4)
    },
    mutations: {
      retry: 1
    }
  }
}), Y = J(30 * 60 * 1e3), ct = () => {
  Y.clear();
}, q = ({
  children: e,
  queryClient: t = Y,
  perRequestServerQueryClient: r = !1
}) => {
  const [s] = G(
    () => r && typeof window > "u" ? J(1 / 0) : void 0
  );
  return /* @__PURE__ */ v(ve, { client: s ?? t, children: e });
};
q.displayName = "SearchResultReactQueryProvider";
const ee = P(
  null
), Fe = () => x(ee), te = P(void 0);
function Ie() {
  return x(te);
}
const ke = (e) => {
  var n, a;
  const t = {
    globalSearchSettings: e.globalSearchSettings,
    searchData: e.searchData,
    structuredDataMapper: e.structuredDataMapper
  }, r = {
    facets: ((n = e.facetSorting) == null ? void 0 : n.facets) ?? "auto",
    values: ((a = e.facetSorting) == null ? void 0 : a.values) ?? "auto"
  }, s = e.excludedFacets ?? [];
  return /* @__PURE__ */ v(b.Provider, { value: t, children: /* @__PURE__ */ v(B.Provider, { value: s, children: /* @__PURE__ */ v(ee.Provider, { value: e.facetGrouping ?? null, children: /* @__PURE__ */ v(z.Provider, { value: r, children: /* @__PURE__ */ v(te.Provider, { value: e.formatRangeValue, children: /* @__PURE__ */ v(
    q,
    {
      perRequestServerQueryClient: e.perRequestServerQueryClient,
      children: e.children
    }
  ) }) }) }) }) });
};
ke.displayName = "SearchProvider";
const ot = {
  search: "search"
}, re = P(void 0), at = (e) => {
  const t = {
    autoCompleteClient: e.autoCompleteClient
  };
  return /* @__PURE__ */ v(re.Provider, { value: t, children: e.children });
}, Qe = () => {
  const e = x(re);
  if (!e)
    throw new Error(
      "useAutoCompleteClient must be used within a AutoCompleteProvider"
    );
  return e.autoCompleteClient;
}, it = () => {
  const e = Qe();
  return Pe(async (r) => {
    try {
      return await e.search(r);
    } catch (s) {
      throw s;
    }
  });
};
function Le(e, t) {
  switch (t.type) {
    case "SET_RESULT":
      return {
        ...e,
        result: t.payload
      };
    case "LOAD_PAGE":
      return e.result ? {
        ...e,
        result: {
          ...e.result,
          items: [...e.result.items, ...t.payload.items],
          meta: {
            ...e.result.meta,
            currentPage: t.payload.page
          }
        }
      } : e;
    default:
      return e;
  }
}
const ne = P(void 0), se = P(void 0);
function E() {
  const e = x(ne);
  if (e === void 0)
    throw new Error(
      "useSearchResultState must be used within a SearchResultProvider"
    );
  return e;
}
function De() {
  var t;
  return (t = E().result) == null ? void 0 : t.items;
}
const ce = () => {
  const e = x(b);
  if (!e)
    throw new Error(
      "useStructuredDataProductsMapper must be used within a SearchProvider"
    );
  return e.structuredDataMapper;
}, Me = (e) => {
  const t = De(), r = ce(), s = R(() => {
    if (!r)
      return;
    const n = [];
    return t == null || t.forEach((a) => {
      a.type === "product" && n.push(r(a.product));
    }), n;
  }, [t]);
  return Ce(s), null;
}, oe = P(void 0), ae = (e) => {
  const [t, r] = ge(Le, {
    result: e.result
  }), s = W(!0), n = ce();
  return Se(() => {
    s.current ? s.current = !1 : r({ type: "SET_RESULT", payload: e.result });
  }, [e.result]), /* @__PURE__ */ v(ne.Provider, { value: t, children: /* @__PURE__ */ ye(se.Provider, { value: r, children: [
    n && /* @__PURE__ */ v(Me, {}),
    e.children
  ] }) });
};
ae.displayName = "SearchResultProvider";
const Ve = (e, t, r) => {
  const s = t && Object.keys(t).length > 0, n = r && r.length > 0;
  return s && n ? ["search", e, "facets", t, "sort", r] : s ? ["search", e, "facets", t] : n ? ["search", e, "sort", r] : ["search", e];
}, I = (e, t, r) => Ve(
  e,
  Object.keys(t).length > 0 ? t : void 0,
  r.length > 0 ? r : void 0
), k = (e, t) => {
  const r = e.values.map((n) => n.id === t ? {
    ...n,
    selected: !n.selected
  } : n), s = r.filter((n) => n.selected).length;
  return {
    ...e,
    values: r,
    selectedCount: s
  };
}, ie = (e, t) => e.map((r) => {
  if (r.id === t) {
    const s = !r.selected;
    if (r.children && r.children.length > 0) {
      const n = (a) => a.map((o) => ({
        ...o,
        selected: s,
        children: o.children ? n(o.children) : o.children
      }));
      return {
        ...r,
        selected: s,
        children: n(r.children)
      };
    } else
      return {
        ...r,
        selected: s
      };
  }
  return r.children ? {
    ...r,
    children: ie(r.children, t)
  } : r;
}), ue = (e) => e.map((t) => {
  if (t.children && t.children.length > 0) {
    const r = ue(t.children), s = r.every(
      (n) => n.selected
    );
    return {
      ...t,
      selected: s,
      children: r
    };
  }
  return t;
}), Q = (e, t) => {
  const r = ie(e.values, t), s = ue(r), n = (o) => o.reduce((d, c) => {
    let i = c.selected ? 1 : 0;
    return c.children && (i += n(c.children)), d + i;
  }, 0), a = n(s);
  return {
    ...e,
    values: s,
    selectedCount: a
  };
}, L = (e) => {
  const t = [];
  for (const r of e)
    r.selected && t.push(r), r.children && t.push(
      ...L(r.children)
    );
  return t;
}, Ne = (e) => {
  const t = [], r = (s) => {
    for (const n of s) {
      if (n.selected) {
        t.push(n);
        continue;
      }
      n.children && n.children.length > 0 && r(n.children);
    }
  };
  return r(e), t;
}, D = (e, t, r) => ({
  ...e,
  selectedMin: t,
  selectedMax: r
}), Xe = (e) => {
  const t = {};
  return e.forEach((r, s) => {
    if (s.startsWith("facet_")) {
      const n = s.replace("facet_", "");
      t[n] = r.split(",");
    }
  }), t;
}, Oe = (e) => {
  const t = e.get("sort");
  return t ? t.split(",") : [];
}, Te = (e) => {
  const t = e.split(":");
  if (t.length !== 2)
    return;
  const r = Number(t[0]), s = Number(t[1]);
  if (!(Number.isNaN(r) || Number.isNaN(s)))
    return { min: r, max: s };
}, $ = (e, t, r, s) => {
  const n = new URLSearchParams(r);
  for (const [o] of r.entries())
    o.startsWith("facet_") && n.delete(o);
  n.delete("sort"), e.forEach((o) => {
    let d = [];
    if (o.type === "checkbox")
      d = o.values.filter((c) => c.selected).map((c) => c.id);
    else if (o.type === "checkbox-hierarchical")
      d = L(o.values).map((i) => i.id);
    else if (o.type === "group")
      o.children.forEach((c) => {
        let i = [];
        c.type === "checkbox" ? i = c.values.filter((u) => u.selected).map((u) => u.id) : c.type === "checkbox-hierarchical" && (i = L(c.values).map((m) => m.id)), i.length > 0 && n.set(
          `facet_${c.id}`,
          i.join(",")
        );
      });
    else if (o.type === "range") {
      const c = o.selectedMin ?? o.min, i = o.selectedMax ?? o.max;
      (c !== o.min || i !== o.max) && n.set(
        `facet_${o.id}`,
        `${c}:${i}`
      );
    }
    o.type !== "group" && o.type !== "range" && d.length > 0 && n.set(`facet_${o.id}`, d.join(","));
  });
  const a = t.filter((o) => o.selected).map((o) => o.id);
  a.length > 0 && n.set("sort", a.join(",")), window.history.replaceState(
    null,
    "",
    `${s}?${n.toString()}`
  );
}, ut = (e, t) => {
  const r = new URLSearchParams(e);
  for (const [s] of e.entries())
    s.startsWith("facet_") && r.delete(s);
  r.delete("sort"), window.history.replaceState(
    null,
    "",
    `${t}?${r.toString()}`
  );
}, _e = async (e, t, r, s) => {
  let n = e;
  for (const [a, o] of Object.entries(t)) {
    const d = n.facets.find((i) => i.id === a);
    if (!d)
      continue;
    if (d.type === "range") {
      const i = o[0] ? Te(o[0]) : void 0;
      if (i) {
        const u = n.facets.map(
          (m) => m.id === a && m.type === "range" ? D(m, i.min, i.max) : m
        );
        n = await s.setFacets(
          u,
          n
        );
      }
      continue;
    }
    let c = [...n.facets];
    for (const i of o)
      d.type === "checkbox" ? c = c.map((u) => u.id === a && u.type === "checkbox" ? k(u, i) : u) : d.type === "checkbox-hierarchical" && (c = c.map((u) => u.id === a && u.type === "checkbox-hierarchical" ? Q(u, i) : u));
    n = await s.setFacets(c, n);
  }
  if (r.length > 0) {
    const a = n.sort.map((o) => ({
      ...o,
      selected: r.includes(o.id)
    }));
    n = await s.setSortOrder(
      a,
      n
    );
  }
  return n;
}, M = (e) => {
  if (!e)
    return { facets: {}, sort: [] };
  const t = e.facets.reduce(
    (s, n) => {
      const a = O(n);
      return a.length > 0 && (s[n.id] = a), s;
    },
    {}
  ), r = le(e.sort || []);
  return { facets: t, sort: r };
}, le = (e) => e.filter((t) => t.selected).map((t) => t.id).sort(), V = (e) => {
  const t = [];
  return Object.keys(e.facets).length > 0 && t.push("facets", e.facets), e.sort.length > 0 && t.push("sort", e.sort), t;
}, O = (e) => {
  var r, s;
  let t = [];
  if (e.type === "checkbox-hierarchical")
    t = de(
      e.values
    );
  else if (e.type === "group")
    t = e.children.flatMap(
      (n) => O(n)
    );
  else if (e.type === "range") {
    const n = e.selectedMin ?? e.min, a = e.selectedMax ?? e.max;
    t = n !== e.min || a !== e.max ? [`${n}:${a}`] : [];
  } else
    t = ((s = (r = e.values) == null ? void 0 : r.filter((n) => n.selected)) == null ? void 0 : s.map((n) => n.id)) || [];
  return t.sort();
}, de = (e) => {
  const t = [];
  for (const r of e)
    r.selected && t.push(r.id), r.children && t.push(...de(r.children));
  return t;
}, Ae = (e, t, r, s, n) => async (a, o) => {
  var c, i;
  const d = ((c = e.data) == null ? void 0 : c.pages.length) || 0;
  if (a === d + 1) {
    const u = await e.fetchNextPage(), m = (i = u.data) == null ? void 0 : i.pages[u.data.pages.length - 1], y = n();
    if (u.data && y) {
      const h = u.data.pages.flatMap(
        (l) => Array.isArray(l) ? l : l && typeof l == "object" && "items" in l ? l.items : []
      ), g = {
        ...y,
        items: h,
        meta: {
          ...y.meta,
          currentPage: u.data.pages.length
        }
      };
      r.setQueryData(s, g);
    }
    return m && typeof m == "object" && "items" in m ? m.items : [];
  }
  return await t.loadPage(a, o);
}, Ue = (e, t, r, s, n, a, o, d) => ({
  ...e,
  // Apply facet filters while maintaining cache and URL state
  setFacets: async (c, i) => {
    const u = await e.setFacets(
      c,
      i
    ), m = (s == null ? void 0 : s.sort) || [], { urlFacetsData: y, urlSortData: h } = d(
      c,
      m
    ), g = I(
      r,
      y,
      h
    );
    return t.setQueryData(g, u), o(u), $(
      c,
      m,
      n,
      a
    ), u;
  },
  // Apply sort order changes while maintaining cache and URL state
  setSortOrder: async (c, i) => {
    const u = await e.setSortOrder(
      c,
      i
    ), m = (s == null ? void 0 : s.facets) || [], { urlFacetsData: y, urlSortData: h } = d(
      m,
      c
    ), g = I(
      r,
      y,
      h
    );
    return t.setQueryData(g, u), o(u), $(
      m,
      c,
      n,
      a
    ), u;
  },
  reset: async () => {
    const c = I(r, {}, []), i = t.getQueryData(c);
    if (i) {
      await t.cancelQueries({
        queryKey: ["search", r, "infinite"],
        exact: !1
      }), t.removeQueries({
        queryKey: ["search", r, "infinite"],
        exact: !1
      });
      const h = new URLSearchParams(n);
      for (const [p] of n.entries())
        p.startsWith("facet_") && h.delete(p);
      h.delete("sort");
      const g = h.toString(), l = g ? `${a}?${g}` : a;
      return window.history.replaceState(null, "", l), await t.invalidateQueries({
        queryKey: ["search", r],
        exact: !1
      }), o(i), window.scrollTo({ top: 0 }), i;
    }
    const u = new URLSearchParams(n);
    for (const [h] of n.entries())
      h.startsWith("facet_") && u.delete(h);
    u.delete("sort");
    const m = u.toString(), y = m ? `${a}?${m}` : a;
    window.location.href = y;
  }
}), K = async (e, t) => {
  await e.cancelQueries({
    queryKey: ["search", t, "infinite"],
    exact: !1
  }), e.removeQueries({
    queryKey: ["search", t, "infinite"],
    exact: !1
  }), window.scrollTo({ top: 0 });
}, $e = ({
  queryParams: e,
  searchMethods: t,
  urlFacets: r = {},
  urlSort: s = [],
  mode: n = "CLIENT",
  initialSearchResult: a
}) => {
  var l;
  const o = Z(), d = R(
    () => I(e, r, s),
    [e, r, s]
  ), c = xe({
    queryKey: d,
    queryFn: async () => {
      if (n === "SSR" && a)
        return a;
      if (Object.keys(r).length > 0 || s.length > 0) {
        const p = await t.fetchSearchResult();
        return await _e(
          p,
          r,
          s,
          t
        );
      }
      return t.fetchSearchResult();
    },
    initialData: n === "SSR" && a ? a : void 0,
    staleTime: n === "SSR" ? 1 / 0 : void 0,
    refetchOnWindowFocus: !1
  }), i = R(
    () => M(c.data),
    [c.data]
  ), u = R(
    () => [
      "search",
      e,
      "infinite",
      ...V(i)
    ],
    [e, i]
  ), m = Re({
    queryKey: u,
    queryFn: async ({ pageParam: p = 1 }) => {
      var S, w;
      if (p === 1) {
        if (!c.data)
          throw new Error("Cannot start infinite query without search data");
        return c.data;
      }
      const f = await t.loadPage(p, c.data);
      return {
        items: f,
        meta: {
          currentPage: p,
          totalPages: ((S = c.data) == null ? void 0 : S.meta.totalPages) || 0,
          totalItems: ((w = c.data) == null ? void 0 : w.meta.totalItems) || 0,
          itemsPerPage: f.length
        }
      };
    },
    getNextPageParam: (p, f) => {
      var w;
      const S = f.length;
      return S < (((w = p.meta) == null ? void 0 : w.totalPages) || 0) ? S + 1 : void 0;
    },
    initialPageParam: 1,
    enabled: !!c.data,
    refetchOnWindowFocus: !1
  }), y = {
    // Load additional pages using infinite query pattern
    loadPage: C(
      Ae(
        m,
        t,
        o,
        d,
        () => c.data
      ),
      [
        m,
        t,
        o,
        d,
        c.data
      ]
    ),
    // Apply facet filters and update base cache
    setFacets: C(
      async (p, f) => {
        const S = await t.setFacets(
          p,
          f
        );
        return await K(o, e), o.setQueryData(d, S), S;
      },
      [t, o, d, e, u]
    ),
    // Apply sort order changes
    setSortOrder: C(
      async (p, f) => {
        const S = await t.setSortOrder(
          p,
          f
        );
        return await K(o, e), o.setQueryData(d, S), S;
      },
      [t, o, e, u]
    ),
    // Reset search to initial state
    reset: C(async () => c.data || await c.refetch().then((p) => p.data), [c])
  }, h = R(
    () => {
      var p;
      return ((p = m.data) == null ? void 0 : p.pages.flatMap((f) => Array.isArray(f) ? f : f && typeof f == "object" && "items" in f ? f.items : [])) || [];
    },
    [m.data]
  );
  return {
    results: R(
      () => {
        var p;
        return c.data ? {
          ...c.data,
          items: h.length > 0 ? h : c.data.items,
          meta: {
            ...c.data.meta,
            currentPage: ((p = m.data) == null ? void 0 : p.pages.length) || 1
          }
        } : void 0;
      },
      [c.data, h, (l = m.data) == null ? void 0 : l.pages.length]
    ),
    queryMethods: y
  };
}, Ke = (e, t, r, s) => {
  const n = M(r), a = [
    "search",
    t,
    "infinite",
    ...V(n)
  ], o = M(s), d = [
    "search",
    t,
    "infinite",
    ...V(o)
  ], c = e.getQueryData(a);
  if (c != null && c.pages && c.pages.length > 1) {
    const i = {
      ...c,
      pages: [s, ...c.pages.slice(1)],
      pageParams: c.pageParams
    };
    e.setQueryData(d, i);
  }
}, je = ({
  queryParams: e,
  searchMethods: t,
  mode: r = "CLIENT",
  initialSearchResult: s,
  children: n
}) => {
  const a = x(b), o = Z();
  if (!a)
    throw new Error(
      "CachedSearchResultsProvider must be used within a SearchProvider"
    );
  const { searchData: d } = a, c = d.urlSearchParams, i = R(
    () => Xe(c),
    [c.toString()]
  ), u = R(
    () => Oe(c),
    [c.toString()]
  ), { results: m, queryMethods: y } = $e({
    queryParams: e,
    searchMethods: t,
    urlFacets: i,
    urlSort: u,
    mode: r,
    initialSearchResult: s
  }), h = (p, f) => {
    const S = p.reduce(
      (F, A) => {
        const U = O(A);
        return U.length > 0 && (F[A.id] = U), F;
      },
      {}
    ), w = le(f);
    return { urlFacetsData: S, urlSortData: w };
  }, g = C(
    (p) => {
      Ke(o, e, m, p);
    },
    [o, e, m]
  ), l = Ue(
    y,
    o,
    e,
    m,
    c,
    d.pathname,
    g,
    h
  );
  return /* @__PURE__ */ v(oe.Provider, { value: l, children: /* @__PURE__ */ v(ae, { result: m, children: n }) });
};
je.displayName = "CachedSearchResultsProvider";
function T() {
  const e = x(se);
  if (e === void 0)
    throw new Error(
      "useSearchResultDispatch must be used within a SearchResultProvider"
    );
  return e;
}
const _ = () => {
  const e = x(oe);
  if (e === void 0)
    throw new Error(
      "useSearchResultQueryMethods must be used within a SearchResultProvider"
    );
  return e;
}, lt = () => {
  const e = x(b);
  if (!e)
    throw new Error(
      "useGlobalSearchSettings must be used within a SearchProvider"
    );
  return e.globalSearchSettings;
}, he = () => {
  const e = x(b);
  if (!e)
    throw new Error("useSearchData must be used within a SearchProvider");
  return e.searchData;
}, He = () => {
  const { loadPage: e } = _(), { result: t } = E(), r = T();
  return async (s) => {
    const n = await e(s, t);
    r({ type: "LOAD_PAGE", payload: { items: n, page: s } });
  };
}, pe = () => {
  const { result: e } = E();
  return e == null ? void 0 : e.meta;
}, Ge = () => {
  const { urlSearchParams: e, pathname: t } = he(), r = pe(), s = r ? r.currentPage + 1 : 0, n = new URLSearchParams(e);
  return n.set("page", s.toString()), `${t}?${n.toString()}`;
}, dt = () => {
  const e = W(!1), t = pe(), r = Ge(), s = He(), [n, a] = G(!1);
  if (!t)
    return {
      loadMore: () => {
      },
      canLoadMore: !1,
      paginationStats: { totalItems: 0, seen: 0 },
      isLoading: !1,
      pageIncrementHref: r
    };
  const { currentPage: o, totalPages: d, itemsPerPage: c, totalItems: i } = t;
  o === 0 && !e.current && (e.current = !0);
  const u = o + (e.current ? 1 : 0) < d, m = () => {
    if (u)
      return a(!0), s(o + 1).finally(() => a(!1));
    console.warn(
      `Tried to load more products than available, currentPage: ${o}, totalPages: ${d}`
    );
  }, y = (o + (e.current ? 1 : 0)) * c > i ? i : (o + (e.current ? 1 : 0)) * c;
  return {
    loadMore: m,
    canLoadMore: u,
    paginationStats: { totalItems: i, seen: y },
    isLoading: n,
    pageIncrementHref: r
  };
}, ht = () => {
  const e = E(), t = T(), { setSortOrder: r } = _(), s = R(() => {
    var a;
    return ((a = e.result) == null ? void 0 : a.sort) || [];
  }, [e.result]), n = C(
    async (a) => {
      const o = s.map((c) => c.id === a ? {
        ...c,
        selected: !c.selected
      } : {
        ...c,
        selected: !1
        // Only one sort can be selected at a time
      });
      if (!o)
        return;
      const d = await r(o, e.result);
      t({ type: "SET_RESULT", payload: d });
    },
    [s, r, t]
  );
  return { sortAlternatives: s, toggleSort: n };
}, We = (e, t) => {
  const r = [], s = /* @__PURE__ */ new Set();
  for (const a of t) {
    const o = e.filter(
      (d) => a.facetIds.includes(d.id) && (d.type === "checkbox" || d.type === "checkbox-hierarchical")
    );
    if (o.length > 0) {
      const d = o.reduce(
        (i, u) => i + u.selectedCount,
        0
      ), c = {
        id: a.id,
        name: a.name,
        type: "group",
        children: o,
        selectedCount: d,
        relationship: a.relationship || "or",
        compositeField: a.compositeField
      };
      r.push(c), o.forEach((i) => s.add(i.id));
    }
  }
  const n = e.filter(
    (a) => !s.has(a.id)
  );
  return r.push(...n), r;
}, fe = (e) => {
  if (e.type === "group")
    return {
      ...e,
      children: e.children.map(fe)
    };
  if (e.type === "checkbox")
    return {
      ...e,
      values: e.values.filter((t) => t.name !== "undefined")
    };
  if (e.type === "checkbox-hierarchical") {
    const t = (r) => r.filter((s) => s.name !== "undefined").map((s) => ({
      ...s,
      children: s.children ? t(s.children) : void 0
    }));
    return {
      ...e,
      values: t(e.values)
    };
  }
  return e;
}, me = (e) => e.type === "group" ? e.children.some(me) : e.type === "checkbox" || e.type === "checkbox-hierarchical" ? e.values.length > 0 : e.type === "range" ? e.min !== e.max : !0, Ze = /* @__PURE__ */ new Set(["ONE SIZE", "ONESIZE", "ONE-SIZE", "OS"]), ze = [
  "XXXS",
  "XXS",
  "XS",
  "S",
  "M",
  "L",
  "XL",
  "XXL",
  "XXXL",
  "XXXXL",
  "XXXXXL"
], Be = -1;
function Je(e) {
  const t = e.trim().toUpperCase(), r = t.match(/^(\d+)\s*(XL|XS)$/);
  if (r) {
    const s = r[1], n = r[2];
    if (s && n) {
      const a = n === "XL" ? "L" : "S";
      return "X".repeat(Number(s)) + a;
    }
  }
  return t;
}
function j(e) {
  const t = Je(e);
  if (Ze.has(t))
    return Be;
  const r = ze.indexOf(t);
  return r === -1 ? null : r;
}
function H(e) {
  const t = e.trim().match(/^(\d+(?:[.,]\d+)?)/), r = t == null ? void 0 : t[1];
  return r ? Number(r.replace(",", ".")) : null;
}
function Ye(e, t) {
  const r = j(e), s = j(t);
  if (r !== null && s !== null)
    return r - s;
  if (r !== null)
    return -1;
  if (s !== null)
    return 1;
  const n = H(e), a = H(t);
  return n !== null && a !== null && n !== a ? n - a : e.localeCompare(t, void 0, { numeric: !0 });
}
function N(e, t) {
  return t === "auto" ? e : [...e].sort((r, s) => t === "name" ? Ye(r.name, s.name) : t === "count" ? s.count - r.count : 0);
}
function X(e, t) {
  return N(e, t).map(
    (r) => r.children ? { ...r, children: X(r.children, t) } : r
  );
}
function qe(e, t) {
  return t === "auto" ? e : e.type === "group" ? {
    ...e,
    children: e.children.map((r) => r.type === "checkbox-hierarchical" ? {
      ...r,
      values: X(r.values, t)
    } : { ...r, values: N(r.values, t) })
  } : e.type === "checkbox-hierarchical" ? {
    ...e,
    values: X(e.values, t)
  } : e.type === "range" ? e : { ...e, values: N(e.values, t) };
}
const pt = () => {
  const e = be(), t = Ee(), r = Ie(), s = Fe(), n = E(), a = T(), { setFacets: o, reset: d } = _(), c = R(() => {
    var g;
    if (!((g = n.result) != null && g.facets))
      return [];
    let h = n.result.facets.sort((l, p) => e.facets === "count" ? 0 : e.facets === "name" ? l.name.localeCompare(p.name) : 0).filter((l) => l.id && !t.includes(l.id));
    if (s) {
      const l = s();
      h = We(h, l);
    }
    return h = h.map(fe), h = h.filter(me), h = h.map(
      (l) => qe(l, e.values ?? "auto")
    ), h;
  }, [
    n.result,
    e.facets,
    e.values,
    t,
    s
  ]), i = R(() => {
    const h = [], g = (l) => {
      if (l.type === "checkbox-hierarchical")
        Ne(
          l.values
        ).forEach((f) => {
          h.push({
            name: f.name,
            id: f.id,
            facetId: l.id
          });
        });
      else if (l.type === "checkbox")
        l.values.forEach((p) => {
          p.selected && h.push({
            name: p.name,
            id: p.id,
            facetId: l.id
          });
        });
      else if (l.type === "range") {
        const p = l.selectedMin ?? l.min, f = l.selectedMax ?? l.max;
        if (p !== l.min || f !== l.max) {
          const S = r ?? String;
          h.push({
            name: `${S(p)} – ${S(f)}`,
            id: l.id,
            facetId: l.id
          });
        }
      } else
        l.type === "group" && l.children.forEach(g);
    };
    return c.forEach(g), h;
  }, [c, r]), u = C(
    async (h, g) => {
      const l = c.map((f) => {
        if (f.type === "group") {
          const S = f.children.map((w) => {
            if (w.id === h) {
              if (w.type === "checkbox-hierarchical")
                return Q(w, g);
              if (w.type === "checkbox")
                return k(w, g);
            }
            return w;
          });
          return {
            ...f,
            children: S,
            selectedCount: S.reduce(
              (w, F) => w + F.selectedCount,
              0
            )
          };
        } else if (f.id === h) {
          if (f.type === "checkbox-hierarchical")
            return Q(f, g);
          if (f.type === "checkbox")
            return k(f, g);
          if (f.type === "range")
            return D(f, f.min, f.max);
        }
        return f;
      }), p = await o(
        l,
        n.result
      );
      a({ type: "SET_RESULT", payload: p });
    },
    [c, o, a, n.result]
  ), m = C(
    async (h, g, l) => {
      const p = c.map(
        (S) => S.id === h && S.type === "range" ? D(S, g, l) : S
      ), f = await o(p, n.result);
      a({ type: "SET_RESULT", payload: f });
    },
    [c, o, a, n.result]
  );
  return { facets: c, toggleFacet: u, setFacetRange: m, resetFacets: async () => {
    const h = await d();
    a({ type: "SET_RESULT", payload: h });
  }, activeFacetValues: i };
}, ft = ({
  zeroIndexed: e = !1
} = {}) => {
  const { urlSearchParams: t } = he(), r = t.get("page"), s = r ? parseInt(r) : 1;
  return (isNaN(s) || s < 1 ? 1 : s) - (e ? 1 : 0);
}, mt = {
  items: [],
  meta: {
    totalItems: 0,
    currentPage: 1,
    totalPages: 1,
    itemsPerPage: 0
  },
  facets: [],
  sort: []
}, gt = (e) => e.relationship !== "and" ? [] : e.children.map((t) => ({
  facetId: t.id,
  valueIds: t.values.filter((r) => r.selected).map((r) => r.id)
})).filter((t) => t.valueIds.length > 0);
export {
  at as AutoCompleteProvider,
  je as CachedSearchResultsProvider,
  ke as SearchProvider,
  ae as SearchResultProvider,
  q as SearchResultReactQueryProvider,
  Me as StructuredDataSearchProducts,
  ot as autoCompleteClientMethods,
  ct as clearSearchResultCache,
  ut as clearSearchUrlParameters,
  L as collectSelectedCheckboxHierarchicalValues,
  de as collectSelectedHierarchicalIds,
  Ne as collectTopMostSelectedCheckboxHierarchicalValues,
  Ye as compareSizeFacetValues,
  Ue as createEnhancedQueryMethods,
  V as createFilterKeyFragment,
  Ae as createLoadPageMethod,
  mt as emptySearchResult,
  B as excludedFacetsContext,
  M as extractFilterState,
  O as extractSelectedFacetIds,
  le as extractSelectedSortIds,
  ee as facetGroupingContext,
  z as facetSortingContext,
  fe as filterUndefinedValues,
  te as formatRangeValueContext,
  I as generateSearchQueryKey,
  gt as getAndGroupActiveSelections,
  We as groupFacets,
  me as hasValues,
  Ke as migrateInfiniteQueryData,
  Te as parseFacetRangeValue,
  Xe as parseUrlFacets,
  Oe as parseUrlSort,
  _e as restoreSelectionsFromUrl,
  b as searchContext,
  oe as searchResultQueryMethodsContext,
  Le as searchResultReducer,
  se as searchResultReducerDispatch,
  ne as searchResultReducerState,
  D as setRangeFacetValue,
  k as toggleCheckboxFacet,
  Q as toggleHierarchicalFacet,
  $ as updateUrlWithSearchState,
  Qe as useAutoCompleteClient,
  it as useAutoCompleteSearch,
  $e as useCachedSearchResults,
  ft as useCurrentPaginationPage,
  Ee as useExcludedFacets,
  Fe as useFacetGrouping,
  be as useFacetSorting,
  pt as useFacets,
  Ie as useFormatRangeValue,
  lt as useGlobalSearchSettings,
  Ge as usePageIncrementedHref,
  he as useSearchData,
  T as useSearchResultDispatch,
  De as useSearchResultItems,
  dt as useSearchResultLoadMore,
  He as useSearchResultLoadPage,
  pe as useSearchResultMeta,
  _ as useSearchResultQueryMethods,
  E as useSearchResultState,
  ht as useSort,
  ce as useStructuredDataProductsMapper
};
